module.exports = __webpack_public_path__ + "img/product_2.12f7513.jpg";